import React from "react";

const Spacer = ({ s = 16 }) => (
  <div
    style={{
      height: s
    }}
  />
);

export default Spacer;
